/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Contactsourceperson2Inputs */

const de__field_contactsourceperson2 = /** @type {(inputs: _Field_Contactsourceperson2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktperson`)
};

/**

* @param {_Field_Contactsourceperson2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_contactsourceperson2 = /** @type {((inputs?: _Field_Contactsourceperson2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Contactsourceperson2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_contactsourceperson2(inputs)
});
export { _field_contactsourceperson2 as "_field_contactSourcePerson" }